import React, { Component, Fragment } from 'react';
import './CultuurStation.Module.scss';
import 'react-tippy/dist/tippy.css';

import {
    Tooltip,
  } from 'react-tippy';

class CultuurStation extends Component {

    render() {

        let active = this.props.lesson.cultuurloper;

        if(!active || active == 'null') {
            active = [];
        }

        return (
        <Fragment>
            {/* <h4>Cultuurstation</h4> */}
            <div styleName='grid'>
                <div styleName='grid-heading'>Reflecterend vermogen</div>
                <Tooltip
                // options
                title="verwoordt eigen ervaringen en gevoelens in relatie tot de context"
                position="top"
                trigger="mouseenter"
                theme="dark"
                size='small'
                arrow='true'
                >
                <div styleName={`grid-item ${active.includes('R1') ? 'active' : ''}`}>R1</div>
                </Tooltip>
                <Tooltip
                // options
                title="bedenkt persoonlijke leervragen"
                position="top"
                trigger="mouseenter"
                theme="dark"
                size='small'
                arrow='true'
                >
                <div styleName={`grid-item ${active.includes('R2') ? 'active' : ''}`}>R2</div>
                </Tooltip>
                <div styleName={`grid-item ${active.includes('R3') ? 'active' : ''}`}>R3</div>
                <div styleName={`grid-item ${active.includes('R4') ? 'active' : ''}`}>R4</div>
                <div styleName={`grid-item ${active.includes('R5') ? 'active' : ''}`}>R5</div>
                <div styleName={`grid-item ${active.includes('R6') ? 'active' : ''}`}>R6</div>
                <div styleName={`grid-item ${active.includes('R7') ? 'active' : ''}`}>R7</div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Creerend vermogen</div>
                <div styleName={`grid-item ${active.includes('C1') ? 'active' : ''}`}>C1</div>
                <div styleName={`grid-item ${active.includes('C2') ? 'active' : ''}`}>C2</div>
                <div styleName={`grid-item ${active.includes('C3') ? 'active' : ''}`}>C3</div>
                <div styleName={`grid-item ${active.includes('C4') ? 'active' : ''}`}>C4</div>
                <div styleName={`grid-item ${active.includes('C5') ? 'active' : ''}`}>C5</div>
                <div styleName={`grid-item ${active.includes('C6') ? 'active' : ''}`}>C6</div>
                <div styleName=''></div>
                <div styleName=''></div>
                {/* <div styleName='spacer-grid'></div> */}
                <div styleName='grid-heading'>Onderzoekend vermogen</div>
                <div styleName={`grid-item ${active.includes('O1') ? 'active' : ''}`}>O1</div>
                <div styleName={`grid-item ${active.includes('O2') ? 'active' : ''}`}>O2</div>
                <div styleName={`grid-item ${active.includes('O3') ? 'active' : ''}`}>O3</div>
                <div styleName={`grid-item ${active.includes('O4') ? 'active' : ''}`}>O4</div>
                <div styleName={`grid-item ${active.includes('O5') ? 'active' : ''}`}>O5</div>
                <div styleName={`grid-item ${active.includes('O6') ? 'active' : ''}`}>O6</div>
                <div styleName={`grid-item ${active.includes('O7') ? 'active' : ''}`}>O7</div>
                <div styleName={`grid-item ${active.includes('O8') ? 'active' : ''}`}>O8</div>
                {/* <div styleName='spacer-grid'></div> */}
            </div>
        </Fragment>
        );
    }
}

export default CultuurStation;